import { Button, Card, Text } from '@fragments';
import { IconPlus } from '@tabler/icons-react';

import './styles.scss';

/**
 * "Available platform" card for the Pixel and Integrations settings.
 * Row 1: logo · platform name · rounded "+" (the only action, so the card
 * itself is not interactive). Row 2: what connecting it does, on at most two
 * lines. Composes the Card fragment; the logo fills its icon chip.
 *
 * @param {string}    [logo]        Image source for the brand logo.
 * @param {Component} [icon]        Glyph component used when there is no logo.
 * @param {string}    name
 * @param {string}    description
 * @param {string}    addLabel      Tooltip / aria-label of the "+" button.
 * @param {() => void} onAdd
 */
export default function PlatformCard({ logo, icon: Glyph, name, description, addLabel, onAdd }) {
    return (
        <Card
            flat
            className="platform-card"
            icon={logo ? <img src={logo} alt="" /> : Glyph ? <Glyph /> : null}
            title={name}
            action={
                <Button
                    icon={<IconPlus />}
                    variant="rounded"
                    color="inverse"
                    size="small"
                    onClick={onAdd}
                    tooltip={addLabel}
                    aria-label={addLabel}
                    preventLoading
                />
            }
        >
            <Text.span contrast={6} maxLines={2}>{description}</Text.span>
        </Card>
    );
}

/** Responsive grid of PlatformCards. */
export function PlatformGrid({ children }) {
    return <div className="platform-grid">{children}</div>;
}
